export function toCurrency(number) {
  const integer = parseInt(number);
  const currency = (integer / 100).toFixed(2);
  return currency;
}
